import { render, staticRenderFns } from "./CashAndCoupons_Detail.vue?vue&type=template&id=3c584f55"
import script from "./CashAndCoupons_Detail.vue?vue&type=script&lang=js"
export * from "./CashAndCoupons_Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports